import { render } from "./DetailComponent4.vue?vue&type=template&id=1cbf3256&scoped=true"
import script from "./DetailComponent4.vue?vue&type=script&lang=js"
export * from "./DetailComponent4.vue?vue&type=script&lang=js"

import "./DetailComponent4.vue?vue&type=style&index=0&id=1cbf3256&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cbf3256"]])

export default __exports__